import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { validateUser } from '../../store/actions/auth'

import { PATHS, ErrorMessages } from '../../common/constants';
import Anchor from '../../components/Anchor';
import Auth from '../../layouts/Auth';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import FontAwesomeIcon from '../../components/Icon';

import { Images } from '../../Tenants';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import Loader from '../../components/Loader';
import { ToastInfo, ToastFail } from '../../helpers/validationHelper';
import * as client from "../../services/client";
import LinkValidation from '../LinkValidation/LinkValidation';

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: '',
      password: '',
      confirm_password: '',
      validated: false,
      passwordError: '',
      confirmPasswordError: '',
      pageloaded: false,
      loading: false,
      message: '',
      errors: {
        passwordCapitalError: true,
        passwordLowerError: true,
        passwordNumberError: true,
        passwordLengthError: true,
        passwordSpecialCharecterError: true
      },

    }
  }

  componentDidMount () {
    this.setState({ loading: true });
    const location = this.props.location;    
    let slugCode = location.search?.split('code=')[1]?.split('&')[0] || "";
    let email = location.search?.split('email=')[1]?.split('&')[0] || "";
    if(slugCode && email) {
      this.onValidateUrl(email, slugCode);
    } else {
      ToastFail("Invalid link");
      this.setState({ pageloaded: false, loading: false, message: "" });
    }
  }
  /*
    Modified By: Sai Prasad
    Modified Date: 15/09/2022
    Jira Ticket: JUN-3215
    Description: function to validate user reset password url
  */
  onValidateUrl = (email, slugCode) => {
    return client.validateURL(email, slugCode).then(response => {
      if (response.status === 200 || response.ok) {
        response.json().then(responsejson => {
          if (responsejson.statusCode === 200) {            
            this.setState({ pageloaded: true, loading: false, message: '' });
          } else if (responsejson.statusCode === 401) {
            this.setState({ pageloaded: false, loading: false, message: responsejson.message });
          } else if (responsejson.statusCode === 300) {
            this.setState({ pageloaded: false, loading: false, message: "Link has already been used" });
          } else if (responsejson.statusCode === 404) {
            this.setState({ pageloaded: false, loading: false, message: responsejson.message });
          } else {
            ToastFail(ErrorMessages.error);
            this.setState({ pageloaded: false, loading: false, message: '' });
          }
        })
      } else {
        ToastFail(ErrorMessages.error);
        this.setState({ pageloaded: false, loading: false, message: '' });
      }
    }).catch(() => {
      this.setState({ pageloaded: false, loading: false, message: '' });
      ToastFail(ErrorMessages.error);
    })
  }
  /*
    Modified By: Sai Prasad
    Modified Date: 23/08/2022 2:55 PM
    Jira Ticket: JUN-3109
    Description: validate slug code and password checking code changes
  */

  validatePassword() {
    const { onValidateUser } = this.props;
    let { password, confirm_password, passwordError, confirmPasswordError } = this.state;
    if (passwordError && confirmPasswordError) {
      if (password === confirm_password) {
        let slugCode = this.props.location.search.split('code=')[1].split('&')[0];
        let email = this.props.location.search.split('email=')[1].split('&')[0];
        let params = {
          email: email,
          code: slugCode,
          password: password,
          newPassword: password,
          type: 'Reset Password'
        };
        onValidateUser(params, this.props.history);
      } else {
        ToastInfo(ErrorMessages.passwordValidation)
      }
    }
  }
  onChangePasssword = (text, type) => {
    this.setState({ [type]: text })
    this.checkPasswordRequirements(text, type);
  }
  onFocus = (text, type) => {
    this.checkPasswordRequirements(text, type);
  }

  /*
    Modified By: Sai Prasad
    Modified Date: 06/10/2022
    Jira Ticket: JUN-3323
    Description: password requirements.
 */
  checkPasswordRequirements = (text, type) => {
    const { errors } = this.state;
    let passwordCapital = /(?=.*[A-Z])/;
    let passwordLower = /(?=.*[a-z])/;
    let passwordNumber = /(?=.*\d)/;
    let passwordSpecialCharecter = /[!@#\$%\^\&*\)\(+=._-]/
    errors.passwordLengthError = (text.trim().length < 8 || text.trim().length > 20) ? true : false;
    errors.passwordCapitalError = passwordCapital.test(text.trim()) ? false : true;
    errors.passwordLowerError = passwordLower.test(text.trim()) ? false : true;
    errors.passwordNumberError = passwordNumber.test(text.trim()) ? false : true;
    errors.passwordCapitalError = passwordCapital.test(text.trim()) ? false : true;
    errors.passwordSpecialCharecterError = passwordSpecialCharecter.test(text.trim()) ? false : true;
    let validation = !errors.passwordLengthError && !errors.passwordCapitalError && !errors.passwordLowerError && !errors.passwordNumberError &&
      !errors.passwordCapitalError && !errors.passwordSpecialCharecterError

    this.setState({ errors })
    this.setState(type === 'password' ? { passwordError: validation } : { confirmPasswordError: validation })
  }

  render() {
    const { errors, pageloaded, loading, message } = this.state;
    return (
      loading ?  <Loader center={true}/> :
      pageloaded ? 
      <Auth
        title="Reset Password"
        backgroundImage={Images.signInImage}
        content={(
          <>
            <div className="sign-in">
              <form
                onSubmit={e => {
                  e.preventDefault();
                  this.validatePassword()
                }}
              >
                <div className="sign-in__header">
                  <div className="sign-in__headline">
                    {/* {this.props.location.state.title} */}
                    Reset Password
                  </div>
                </div>
                <Input
                  value={this.state.password}
                  onChange={e => this.onChangePasssword(e.target.value, 'password')}
                  onfocus={() => this.onFocus(this.state.password, 'password')}
                  label="Password"
                  required
                  mask
                  block
                />
                <Input
                  value={this.state.confirm_password}
                  onChange={e => this.onChangePasssword(e.target.value, 'confirm_password')}
                  onfocus={() => this.onFocus(this.state.confirm_password, 'confirm_password')}
                  label="Confirm Password"
                  required
                  mask
                  block
                />
                 {this.props.loader && (
                  <Loader center={true} />
                )}
                {!this.state.passwordError || !this.state.confirmPasswordError ?
                  <div style={{ marginBottom: 20 }}>
                    <div style={{ fontSize: 25, marginBottom: 10 }}>Password Requirements:</div>
                    {/* <Icon glyph="check" weight="solid" size="small" /> */}
                    <div style={{ color: errors.passwordLengthError ? 'red' : 'green', fontSize: 14, marginBottom: 3 }}>
                      <FontAwesomeIcon glyph={errors.passwordLengthError ? "times" : "check"} weight="solid" size="small" />
                <label style={{ paddingLeft: 10 }}>{ErrorMessages.passwordRequirement1}</label>
                    </div>
                    <div style={{ color: errors.passwordCapitalError ? 'red' : 'green', fontSize: 14, marginBottom: 3 }}>
                      <FontAwesomeIcon glyph={errors.passwordCapitalError ? "times" : "check"} weight="solid" size="small" />
                      <label style={{ paddingLeft: 10 }}>{ErrorMessages.passwordRequirement2}</label>
                    </div>
                    <div style={{ color: errors.passwordLowerError ? 'red' : 'green', fontSize: 14, marginBottom: 3 }}>
                      <FontAwesomeIcon glyph={errors.passwordLowerError ? "times" : "check"} weight="solid" size="small" />
                      <label style={{ paddingLeft: 10 }}>{ErrorMessages.passwordRequirement3}</label>
                    </div>
                    <div style={{ color: errors.passwordNumberError ? 'red' : 'green', fontSize: 14, marginBottom: 3 }}>
                      <FontAwesomeIcon glyph={errors.passwordNumberError ? "times" : "check"} weight="solid" size="small" />
                      <label style={{ paddingLeft: 10 }}>{ErrorMessages.passwordRequirement4}</label>
                    </div>
                    <div style={{ color: errors.passwordSpecialCharecterError ? 'red' : 'green', fontSize: 14, marginBottom: 3 }}>
                      <FontAwesomeIcon glyph={errors.passwordSpecialCharecterError ? "times" : "check"} weight="solid" size="small" />
                      <label style={{ paddingLeft: 10 }}>{ErrorMessages.passwordRequirement5}</label>
                    </div>
                  </div> : null}
                <div className="sign-in__button">
                  <Button
                    label="Reset Password"
                    color="teal"
                    submit
                    block
                    disabled={!this.state.passwordError || !this.state.confirmPasswordError}
                  />
                </div>
                <div className="sign-in__footer">
                  Remember your password?
                  {' '}
                  <Anchor
                    path={PATHS.AUTH_SIGN_IN}
                    label="Sign In"
                  />
                </div>
              </form>
            </div>
          </>
        )}
      />
      : 
      <LinkValidation message={message}/>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  loader: selectFormLoader(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({
  onValidateUser: validateUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);


